import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, memo, useImperativeHandle, } from 'react';
import { runKeyHandler } from '@material-ui/pickers/_shared/hooks/useKeyDown';
import { styled, useChange, useEventCallback, useRefState, } from '../../../../foundation';
import { TIME_SYSTEM_TEXT } from './constant';
import { StyledTimeIconButton } from './styles';
import { RcTimePickerUtils } from './utils';
import { isClick } from './utils/A11yUtils';
var _ToggleText = memo(forwardRef(function (_a, ref) {
    var onUpdateValue = _a.onUpdateValue, onInnerChange = _a.onInnerChange, value = _a.value, size = _a.size, disabled = _a.disabled, getScreenReaderLabel = _a.getScreenReaderLabel, onClose = _a.onClose, periodTexts = _a.periodTexts, rest = __rest(_a, ["onUpdateValue", "onInnerChange", "value", "size", "disabled", "getScreenReaderLabel", "onClose", "periodTexts"]);
    var _b = __read(useRefState(value), 2), innerValueRef = _b[0], setInnerValue = _b[1];
    useChange(function () {
        if (innerValueRef.current !== value) {
            setInnerValue(value, false);
        }
    }, function () { return value; });
    var innerValue = innerValueRef.current;
    var label = getScreenReaderLabel === null || getScreenReaderLabel === void 0 ? void 0 : getScreenReaderLabel(innerValue);
    var nextValue = innerValue === TIME_SYSTEM_TEXT.AM
        ? TIME_SYSTEM_TEXT.PM
        : TIME_SYSTEM_TEXT.AM;
    var handleClick = useEventCallback(function (event) {
        if (disabled || !isClick(event))
            return;
        onUpdateValue(nextValue);
    });
    var handleToggleKeyDown = useEventCallback(function (event) {
        if (disabled) {
            return;
        }
        var togglePeriod = function () {
            setInnerValue(nextValue);
            onInnerChange === null || onInnerChange === void 0 ? void 0 : onInnerChange(nextValue);
        };
        var keydownSubmit = function () {
            event.stopPropagation();
            onUpdateValue(innerValue);
            onClose(event);
        };
        runKeyHandler(event.nativeEvent, {
            ArrowUp: togglePeriod,
            ArrowDown: togglePeriod,
            Enter: keydownSubmit,
            ' ': keydownSubmit,
        });
    });
    useImperativeHandle(ref, function () { return ({
        value: innerValue,
    }); }, [innerValue]);
    return (React.createElement(StyledTimeIconButton, __assign({ wrapperSize: size, onClick: handleClick, onKeyDown: handleToggleKeyDown, disabled: disabled, color: "informative.f02", "aria-live": "assertive", "aria-label": label }, rest),
        React.createElement(React.Fragment, null, periodTexts[innerValue])));
}));
var ToggleText = styled(_ToggleText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), function (_a) {
    var size = _a.size;
    return RcTimePickerUtils[size].timeSystem.margin;
});
ToggleText.displayName = 'ToggleText';
export { ToggleText };
var templateObject_1;
